import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { NotificationDateCategoryHeader, NotificationList } from './notificationStyles';
import NotificationCard from './NotificationCard';

const NotificationCategoryByTime = ({
  data,
  headerText,
  notificationReadStatusHandler,
  closeDrawer
}) => {
  const { t } = useTranslation(['TRANSLATIONS_RCORE_TOPNAV']);
  const updateNotification = (notificationId) =>
    notificationReadStatusHandler(notificationId, headerText);
  return (
    <>
      <NotificationDateCategoryHeader>{t(headerText)}</NotificationDateCategoryHeader>
      <NotificationList>
        {data.map((type) => (
          <NotificationCard
            key={type.notificationId}
            notificationData={type}
            updateNotification={updateNotification}
            closeDrawer={closeDrawer}
          />
        ))}
      </NotificationList>
    </>
  );
};

// PropType check
NotificationCategoryByTime.propTypes = {
  /**
   * Notification Data
   */
  data: PropTypes.arrayOf(PropTypes.shape({})),
  /**
   * header translation text
   */
  headerText: PropTypes.string,
  /**
   * Notification read status change callback
   */
  notificationReadStatusHandler: PropTypes.func,
  /**
   * Callback to close the drawer
   */
  closeDrawer: PropTypes.func
};

NotificationCategoryByTime.defaultProps = {
  data: {},
  headerText: '',
  notificationReadStatusHandler: undefined,
  closeDrawer: undefined
};

export default NotificationCategoryByTime;
